<template>
  <div class="constainer-fluid">
    <div class="row">
      <div class="col-md-12"></div>
    </div>
    <div class="row px-1 mt-3" v-if="isConnected">
      <div
        v-for="(post, index) in feed"
        :key="index"
        class="border rounded-xl p-4 mb-4 shadow-sm bg-white"
      >
        <!-- Header -->
        <div class="d-flex align-items-center mb-3">
          <img
            :src="churchData?.logoUrl || '/default-avatar.png'"
            alt="Logo"
            class="rounded-circle"
            width="50"
            height="50"
          />
          <div class="ml-3">
            <h6 class="mb-0 font-weight-bold text-dark">
              {{ churchData?.churchName || "Church Page" }}
            </h6>
            <small class="text-muted">{{ formatDate(post.createdTime) }}</small>
          </div>
        </div>
        <p class="text-dark mb-3" v-if="post.message">
          {{
            expandedPosts.has(post.id)
              ? post.message
              : truncatedMessage(post.message)
          }}
          <span
            v-if="post.message.length > 150"
            class="primary--text font-weight-600 cursor-pointer ml-1"
            @click="toggleMessage(post.id)"
          >
            {{ expandedPosts.has(post.id) ? "See less" : "See more" }}
          </span>
        </p>

        <!-- Image (if available) -->
        <div v-if="post.attachments?.length" class="mb-3">
          <img
            :src="post.attachments[0].mediaUrl"
            alt="Post image"
            class="w-100 rounded-xl"
          />
        </div>

        <!-- Actions -->
        <div class="d-flex justify-content-start border-top pt-3">
          <a class="text-decoration-none text-dark mr-4 c-pointer">
            <i class="pi pi-thumbs-up mr-2"></i>Like
          </a>
          <a class="text-decoration-none text-dark mr-4 c-pointer">
            <i class="pi pi-comment mr-2"></i>Comment
          </a>
          <a
            v-if="post.permalink"
            :href="post.permalink"
            target="_blank"
            class="text-decoration-none text-primary"
          >
            View on Facebook
          </a>
        </div>
      </div>

      <div
        class="text-center text-muted mt-4"
        v-if="feed.length === 0 && loadingPost === false"
      >
        No recent posts found.
      </div>
      <div
        class="col-md-12 d-flex justify-content-center mt-4"
        v-if="loadingPost"
      >
        <div style="width: 3rem; height: 3rem" role="status">
          <el-icon :size="38" class="is-loading">
            <Loading />
          </el-icon>
        </div>
      </div>

      <!-- Feed -->
      <div v-if="false" class="col-md-12 mx-auto py-4">
        <div class="row bordered">
          <div class="col-md-12 pt-3 pt-2 main-post">
            <div class="row">
              <div class="col-2 d-md-flex justify-content-center">
                <img
                  :src="churchData.logoUrl"
                  alt="Uploaded Image"
                  class="img-holder bg-secondary"
                />
              </div>

              <div class="col-10 pl-md-0 d-flex align-items-center">
                <textarea
                  name=""
                  id=""
                  rows="4"
                  class="w-100 border-0 textarea"
                  :value="churchData.churchName"
                >
                </textarea>
              </div>
            </div>
          </div>
          <div class="col-md-12 post-add-ons py-2">
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-11">
                <a class="text-decoration-none px-md-4">
                  <span><i class="pi pi-video mr-3"></i></span>
                  <span class="text-dark">Video</span>
                </a>
                <a class="text-decoration-none px-md-4">
                  <span><i class="pi pi-images mr-3"></i></span>
                  <span class="text-dark">Photo/Video</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row bordered my-5"
          v-for="(post, index) in feed"
          :key="index"
        >
          <div class="col-md-12 py-3">
            <!-- User details -->
            <div class="row">
              <div class="col-2 d-md-flex justify-content-center">
                <div class="img-holder bg-secondary"></div>
              </div>
              <div class="col-10 pl-md-0">
                <p
                  class="mb-0 font-weight-700 mb-n2 d-flex justify-content-between"
                >
                  <span><i class="pi pi-ellipsis-h c-pointer"></i></span>
                </p>
                <small class="mb-0">{{ formatDate(post.created_time) }}</small>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 pt-3">
                <h5 class="font-weight-bold mb-0"></h5>
                <p class="mb-0 text-justify">
                  <span>{{ post.message }}</span>
                </p>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-12">
                <a
                  class="text-decoration-none c-pointer post-action-link px-3 px-md-4"
                >
                  <span><i class="pi pi-thumbs-up mr-2"></i></span>
                  <span>Like</span>
                  <span
                    class="ml-2 text-primary"
                    @click="viewLikes(post.id, index)"
                    >{{
                      post && (post.like || post.like == 0)
                        ? post.like
                        : "view likes"
                    }}</span
                  >
                </a>
                <a
                  class="text-decoration-none c-pointer post-action-link px-3 px-md-4"
                >
                  <span><i class="pi pi-comment mr-2"></i></span>
                  <span>Comment</span>
                  <span class="ml-2"></span>
                </a>
              </div>
            </div>

            <div
              class="row my-3"
              v-for="(comment, indx) in post.comments.data"
              :key="indx"
            >
              <div class="col-2 d-md-flex justify-content-center"></div>
              <div>
                <div
                  class="py-2 px-3 small-border-radius"
                  style="background: #ebeef0"
                >
                  <h6 class="mb-0 font-weight-600">
                    {{ comment && comment.from ? comment.from.name : "" }}
                  </h6>
                  <p class="mb-0 small-text">
                    {{ comment.message }}
                  </p>
                </div>
                <div class="px-2">
                  <p class="mb-0"></p>
                </div>
              </div>
            </div>

            <div class="row my-2">
              <div class="col-2 d-md-flex justify-content-center"></div>
              <div class="pl-0 col-10 d-flex align-items-center"></div>
            </div>
          </div>
        </div>
        <div class="row mt-5 justify-content-center text-center h6">
          <div class="col-md-6">{{ facebookResponse }}</div>
        </div>
      </div>
    </div>
    <div
      class="col-md-12 px-0 mt-4 border shadow-lg rounded d-flex justify-content-center align-items-center"
      style="height: 450px"
      v-if="!isConnected && !loaded && !loadingPost"
    >
      <div class="feeds-card">
        <div
          v-if="!isConnected"
          class="connect-box d-flex justify-content-center flex-column align-items-center"
        >
          <img
            src="../../../../assets/social/facebook.svg"
            alt="Instagram"
            width="20"
          />
          <p class="text-center text-black font-weight-600 mt-2">
            Facebook page management <br />
            is not set up yet
          </p>

          <el-button
            round
            :color="primarycolor"
            class="px-5 text-white"
            size="large"
            @click="getfacebookLoginUrl"
          >
            Connect
          </el-button>
        </div>
      </div>
    </div>

    <el-dialog
      v-model="displaySocialIDialog"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      align-center
      style="border-radius: 20px"
    >
      <h3 class="mb-4 text-center text-black">Setup Facebook Integration</h3>
      <div class="row justify-content-center">
        <div class="col-12 col-md-10">
          <div class="row">
            <div class="col-md-12 mb-3">
              <label class="fw-500 s-14 text-black">Facebook App ID</label>
              <el-input
                type="text"
                placeholder="Enter Facebook App ID"
                v-model="facebookAppId"
              />
            </div>

            <div class="col-md-12 mb-3">
              <label class="fw-500 s-14 text-black">Facebook App Secret</label>
              <el-input
                type="text"
                placeholder="Enter Facebook App Secret"
                v-model="facebookAppSecret"
              />
            </div>

            <div class="col-md-12 mt-3 text-center">
              <el-button
                class="text-white px-5 py-4"
                :color="primarycolor"
                round
                :loading="loading"
                @click="saveFacebookCredentials"
              >
                Save & Continue
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="row mt-3" v-if="loadingPost">
      <div class="col-md-12">
        <div class="row my-4">
          <div class="col-md-12">
            <div class="row">
              <div class="col-2 my-2">
                <Skeleton
                  shape="circle"
                  style="width: 100%; height: 70px"
                  class="p-mr-2 small-border-radius"
                ></Skeleton>
              </div>
              <div class="col-10 my-2">
                <Skeleton
                  style="width: 100%; height: 70px"
                  class="small-border-radius"
                ></Skeleton>
              </div>
            </div>
          </div>
          <div class="col-md-12 my-2">
            <Skeleton
              style="width: 100%; height: 200px"
              class="p-mb-2 small-border-radius"
            ></Skeleton>
          </div>
          <div class="col-md-12 d-flex">
            <Skeleton
              width="4rem"
              class="mr-2 small-border-radius"
              height="2rem"
            ></Skeleton>
            <Skeleton
              width="4rem"
              height="2rem"
              class="mr-2 small-border-radius"
            ></Skeleton>
          </div>
        </div>

        <div class="row my-4">
          <div class="col-md-12">
            <div class="row">
              <div class="col-2 my-2">
                <Skeleton
                  shape="circle"
                  style="width: 100%; height: 70px"
                  class="p-mr-2 small-border-radius"
                ></Skeleton>
              </div>
              <div class="col-10 my-2">
                <Skeleton style="width: 100%; height: 70px"></Skeleton>
              </div>
            </div>
          </div>
          <div class="col-md-12 my-2">
            <Skeleton
              style="width: 100%; height: 200px"
              class="p-mb-2"
            ></Skeleton>
          </div>
          <div class="col-md-12 d-flex">
            <Skeleton
              width="4rem"
              class="mr-2 small-border-radius"
              height="2rem"
            ></Skeleton>
            <Skeleton
              width="4rem"
              height="2rem"
              class="mr-2 small-border-radius"
            ></Skeleton>
          </div>
        </div>

        <div class="row my-4">
          <div class="col-md-12">
            <div class="row">
              <div class="col-2 my-2">
                <Skeleton
                  shape="circle"
                  style="width: 100%; height: 70px"
                  class="p-mr-2 small-border-radius"
                ></Skeleton>
              </div>
              <div class="col-10 my-2">
                <Skeleton
                  style="width: 100%; height: 70px"
                  class="small-border-radius"
                ></Skeleton>
              </div>
            </div>
          </div>
          <div class="col-md-12 my-2">
            <Skeleton
              style="width: 100%; height: 200px"
              class="p-mb-2 small-border-radius"
            ></Skeleton>
          </div>
          <div class="col-md-12 d-flex">
            <Skeleton
              width="4rem"
              class="mr-2 small-border-radius"
              height="2rem"
            ></Skeleton>
            <Skeleton
              width="4rem"
              height="2rem"
              class="mr-2 small-border-radius"
            ></Skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";
import Skeleton from "primevue/skeleton";
import social_service from "../../../../services/social/social_service";
import deviceBreakpoint from "../../../../mixins/deviceBreakpoint";
import dateFormatter from "../../../../services/dates/dateformatter";
import axios from "@/gateway/backendapi";
import { ElNotification, ElMessageBox } from "element-plus";
import fb from "axios";
const churchData = ref("");
const postLike = ref([]);
const facebookAuth = ref({});
const fBAuth = ref({});
const facebookResponse = ref("");
const facebookLoginUrl = ref(null);
const displaySocialIDialog = ref(false);
const primarycolor = inject("primarycolor");
const { lgAndUp, xlAndUp, mdAndUp } = deviceBreakpoint();
const facebookAppId = ref("");
const facebookAppSecret = ref("");
const isConnected = ref(false);
const loading = ref(false);
const loadingPost = ref(false);
const expandedPosts = ref(new Set());
const comment = ref({});
const getChurchProfile = async () => {
  try {
    const { data } = await axios.get("/mobile/v1/Profile/GetChurchProfile");
    churchData.value = data.returnObject;
    console.log(churchData);
  } catch (error) {
    console.log(error);
  }
};
getChurchProfile();
const feed = ref([]);

const loaded = ref(false);
const getFeed = async (pageId, accessToken) => {
  try {
    const { data } = await fb.get(
      `https://graph.facebook.com/${pageId}/feed?fields=message,comments.limit(10).summary(true){message,from,likes.limit(0).summary(true)}&access_token=${accessToken}`
    );
    // feed.value = data.data;
    console.log(data.data, "feed data");

    console.log(feed.value);
  } catch (error) {
    console.log(error);
  }
};

const viewLikes = async (objectId, index) => {
  try {
    const { data } = await fb.get(
      `https://graph.facebook.com/${objectId}?fields=likes.summary(true)&access_token=${facebookAuth.value.accessToken}`
    );
    postLike.value = data;
    console.log(postLike.value);
    feed.value[index].like = data.likes.summary.total_count;
  } catch (error) {
    console.log(error);
  }
};
const getfacebookLoginUrl = async () => {
  loading.value = true;
  try {
    const { data } = await axios.get(`/api/MetaBusiness/login`);
    console.log(data, "Facebook login URL");

    if (!data) {
      displaySocialIDialog.value = true;
    } else {
      facebookLoginUrl.value = data;
      openFacebookPopup(data);
    }
  } catch (error) {
    console.error("Failed to get Facebook login URL:", error);
    displaySocialIDialog.value = true;
  } finally {
    loading.value = false;
  }
};
const saveFacebookCredentials = async () => {
  if (!facebookAppId.value || !facebookAppSecret.value) {
    return ElNotification.error(
      "Please enter both Facebook App ID and Secret Key."
    );
  }

  try {
    loading.value = true;

    const { data } = await axios.post(
      `/api/SocialMediaConnectPlatformSettings`,
      {
        appId: facebookAppId.value,
        appSecretKey: facebookAppSecret.value,
      }
    );

    console.log("Credentials saved:", data);
    ElNotification.success("Facebook credentials saved successfully.");
    displaySocialIDialog.value = false;
    await getfacebookLoginUrl();
  } catch (error) {
    ElNotification.error("Failed to save credentials:" || error);
  } finally {
    loading.value = false;
  }
};
const getSocialMediaConnect = async () => {
  try {
    const { data } = await axios.get(`/api/SocialMediaConnectPlatformSettings`);
    console.log(data, "Social Media Settings");
    facebookAuth.value = data;
    fBAuth.value = data;

    if (
      data &&
      data.instagramId !== null &&
      data.instagramId !== "" &&
      data.pageAccessToken !== null &&
      data.pageAccessToken !== ""
    ) {
      // ✅ Connected
      isConnected.value = true;
      getSocialDetails();
      getFeed(facebookAuth.value.pageId, facebookAuth.value.pageAccessToken);
    } else {
      // ❌ Not connected
      isConnected.value = false;
      feed.value = [];
    }
  } catch (error) {
    console.log("Error fetching social media settings:", error);
    isConnected.value = false;
    feed.value = []; // also trigger the connect box
  }
};
getSocialMediaConnect();

const openFacebookPopup = (url) => {
  const popupWidth = 600;
  const popupHeight = 700;
  const left = (window.screen.width - popupWidth) / 2;
  const top = (window.screen.height - popupHeight) / 2;

  // Construct features string correctly
  const features =
    `width=${popupWidth},height=${popupHeight},top=${top},left=${left},` +
    `toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`;

  document.body.classList.add("dim-background");

  // ✅ Use only 3 arguments: url, window name, features
  const popup = window.open(url, "FacebookLoginPopup", features);

  if (!popup) {
    alert("Popup blocked. Please allow popups for this site.");
    document.body.classList.remove("dim-background");
    return;
  }

  popup.focus();

  // Check if popup is closed
  const popupTimer = setInterval(async () => {
    if (popup.closed) {
      clearInterval(popupTimer);
      document.body.classList.remove("dim-background");
      return; // Stop further execution
    }

    try {
      const { data } = await axios.get(
        `/api/SocialMediaConnectPlatformSettings`
      );

      if (data) {
        facebookAuth.value = data;
        fBAuth.value = data;

        const hasUserAccessToken =
          data.userAccessToken && data.userAccessToken.trim() !== "";

        if (hasUserAccessToken) {
          // ✅ Connected successfully
          isConnected.value = true;

          clearInterval(popupTimer); // 🛑 Stop further polling
          document.body.classList.remove("dim-background");

          // 👉 Redirect to connected feed page
          router.push("/tenant/social/feed/connectmetta");
        } else {
          // ❌ Incomplete connection
          isConnected.value = false;
          ElNotification.error("Failed to connect your Social Media Page");

          clearInterval(popupTimer); // 🛑 Stop further polling
          document.body.classList.remove("dim-background");
        }
      } else {
        ElNotification.error("Failed to fetch connection details");

        clearInterval(popupTimer); // 🛑 Stop further polling
        document.body.classList.remove("dim-background");
      }
    } catch (error) {
      ElNotification.error("Failed to verify your Social Media connection");

      clearInterval(popupTimer); // 🛑 Stop further polling
      document.body.classList.remove("dim-background");
    }
  }, 800);
};

const getSocialDetails = async () => {
  loaded.value = true;
  try {
    let { data } = await axios.get(
      "/api/SocialMedia/getSocialDetails?handle=facebook"
    );
    facebookAuth.value = data && data.returnObject ? data.returnObject : {};
    facebookResponse.value = data.response;
    console.log(data);
    getFeed(facebookAuth.value.pageId, facebookAuth.value.accessToken);
    loaded.value = false;
  } catch (error) {
    console.log(error);
  }
};
// const getFaceBookPost = async () => {
// if (
//   fBAuth.value.pageAccessToken == null ||
//   fBAuth.value.pageAccessToken == "" ||
//   fBAuth.value.pageId == null ||
//   fBAuth.value.pageId == ""
// ) {
//   facebookResponse.value =
//     "Facebook page management is not set up yet. Please connect your Facebook page.";
// } else {
// try {
//   const { data } = await axios.get(`/api/MetaBusiness/page/posts`);
//   console.log(data, "getFaceBookPost Posts");
// } catch (error) {
//   console.error("Error fetching Instagram posts:", error);
// }
// }
// };
// getFaceBookPost();
// ✅ Fetch Facebook posts from your backend
const getFacebookPosts = async () => {
  loadingPost.value = true;
  try {
    const { data } = await axios.get(`/api/MetaBusiness/page/posts`);

    if (Array.isArray(data) && data.length > 0) {
      feed.value = data;
      isConnected.value = true;
      loadingPost.value = false;
    } else {
      isConnected.value = false;
      facebookResponse.value =
        "No posts found. Please connect your Facebook page.";
    }
  } catch (error) {
    isConnected.value = false;
    loadingPost.value = false;
    facebookResponse.value = "Failed to load Facebook posts.";
  } finally {
    loadingPost.value = false;
  }
};
getFacebookPosts();

const postComment = async (e, postId, index) => {
  if (!comment.value.message) return false;
  if (e.keyCode == 13) {
    e.preventDefault();
    try {
      const response = await social_service.postComment({
        postId: postId,
        commentMessage: comment.value.message,
        commenterName: "Church Admin",
      });
      feed.value[index].comments.push(response);
      console.log(feed.value);
      comment.value.message = "";
    } catch (error) {
      console.log(error);
    }
  }
};

const formatDate = (date) => {
  return dateFormatter.monthDayTime(date);
};
const toggleMessage = (id) => {
  if (expandedPosts.value.has(id)) {
    expandedPosts.value.delete(id);
  } else {
    expandedPosts.value.add(id);
  }
};

// ✅ Helper to truncate message text
const truncatedMessage = (message, limit = 150) => {
  if (!message) return "";
  if (message.length <= limit) return message;
  return message.substring(0, limit) + "...";
};
</script>

<style scoped>
.blue-bg {
  height: 500px;
  position: absolute;
  background: #0f529f;
  width: 100%;
}

.bg-blue {
  background: #0f529f;
}

.blue-bg:before {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 70%;
  content: "";
  background-color: red;
}

.img-holder {
  border: 1px solid;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  align-items: center;
  display: flex;
  background: white !important;
}
.textarea {
  outline: none;
  margin-top: 10px;
  background: transparent;
}

.post-add-ons {
  background: #f5f6f7;
  border-radius: 0 0 10px 10px;
}

/* .main-post {
          background: #fbfbfb;
      } */

.bordered {
  border: 0.20000000298023224px solid #e9eef0;
  border-radius: 15px;
  background: #fff;
}

.post-action-link {
  color: #4b5257cc;
}

.small-border-radius {
  border-radius: 10px;
}

.medium-border-radius {
  border-radius: 15px;
}

.comment-field {
  width: calc(100% - 60px);
}

.all-platforms {
  background: #136acd;
}

.facebook {
  background: #0f529f;
}

.twitter {
  background: #1a91da;
}

.instagram {
  background: transparent
    linear-gradient(81deg, #e90263 0%, #fd0604 49%, #ff5d00 100%) 0% 0%
    no-repeat padding-box;
}

.whatsapp {
  background: transparent linear-gradient(256deg, #48c658 0%, #2ab540 100%) 0%
    0% no-repeat padding-box;
}

.mobile {
  background: #e87109 0% 0% no-repeat padding-box;
}

@media screen and (min-width: 768px) {
  .b-right {
    border-right: 0.20000000298023224px solid #e9eef0;
  }
}
</style>
